export default "__VITE_ASSET__DgHt1X0p__"